/**
 * FASE 10.4 — Parser tollerante per bozze legacy che memorizzano un array
 * di oggetti come stringa multiline formato "campo1 — campo2 — campo3".
 *
 * Retrocompat: se una pratica D&O aperta prima della 10.4 contiene ancora
 * la vecchia textarea con testo tipo:
 *   "Rossi Mario — Presidente CdA — Dal 2015\nBianchi Anna — Consigliere — Dal 2018"
 * questa funzione tenta di ricostruire l'array `[{cognome_nome, carica, dal_anno}, ...]`.
 *
 * Strategia:
 * 1. Split per newline (`\n` / `\r\n`).
 * 2. Per ogni riga, applica in cascata separatori: " — ", " – ", " - ", " | ", ",".
 * 3. Assegna i chunk ai campi dell'item_schema in ordine di dichiarazione.
 * 4. Se il numero di chunk è < numero campi → tutto va nel primo campo (fallback safe).
 * 5. Se una riga ha "Dal 2015" nell'ultimo chunk, ripulisce il prefisso "Dal ".
 *
 * @param {string} raw    stringa multiline legacy
 * @param {object} itemSchema  { fieldName: {type, label, ...} } (order-preserving)
 * @param {string} _fmt   serialize_as_lines_format (usato solo per detection prefissi)
 * @returns {Array<object>} array di oggetti item pronti per <ArrayField>
 */
export function parseLegacyArrayString(raw, itemSchema, _fmt = "") {
  if (!raw || typeof raw !== "string") return [];
  const trimmed = raw.trim();
  if (!trimmed) return [];

  const schemaKeys = Object.keys(itemSchema || {});
  if (schemaKeys.length === 0) return [];

  const lines = trimmed
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter((l) => l.length > 0);

  const SEPARATORS = [" — ", " – ", " - ", " | ", "|", ";"];

  return lines.map((line) => {
    let chunks = null;
    for (const sep of SEPARATORS) {
      if (line.includes(sep)) {
        chunks = line.split(sep).map((c) => c.trim()).filter(Boolean);
        break;
      }
    }
    if (!chunks) chunks = [line];

    const item = {};
    if (chunks.length >= schemaKeys.length || schemaKeys.length === 1) {
      // Mappatura 1:1 (o schema mono-campo)
      schemaKeys.forEach((k, i) => {
        let v = chunks[i] || "";
        // Pulisci prefissi comuni "Dal ", "dal ", "% "
        v = v.replace(/^Dal\s+/i, "").replace(/^%\s*/, "").replace(/\s*%$/, "");
        const fieldDef = itemSchema[k] || {};
        if (fieldDef.type === "number") {
          const n = parseFloat(v.replace(",", "."));
          item[k] = Number.isFinite(n) ? n : "";
        } else {
          item[k] = v;
        }
      });
    } else {
      // Fallback: metti tutto nel primo campo, gli altri vuoti
      item[schemaKeys[0]] = line;
      schemaKeys.slice(1).forEach((k) => {
        item[k] = itemSchema[k]?.type === "number" ? "" : "";
      });
    }
    return item;
  });
}
